/**
 * @generated SignedSource<<a4eed52bea659a34352c7972ecb4d917>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalTopNavigation$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GlobalTopNavigationView" | "useSideNavToggleStateQuery">;
  readonly " $fragmentType": "GlobalTopNavigation";
};
export type GlobalTopNavigation$key = {
  readonly " $data"?: GlobalTopNavigation$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalTopNavigation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GlobalTopNavigation",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useSideNavToggleStateQuery"
    },
    {
      "kind": "FragmentSpread",
      "name": "GlobalTopNavigationView"
    }
  ],
  "type": "Query"
};

(node as any).hash = "a0da01b6e15222c2256b841b68f170ed";

export default node;
